import { render, staticRenderFns } from "./basePage.vue?vue&type=template&id=0bd28c69&"
import script from "./basePage.vue?vue&type=script&lang=js&"
export * from "./basePage.vue?vue&type=script&lang=js&"
import style0 from "./basePage.vue?vue&type=style&index=0&id=0bd28c69&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports